import React from 'react';
import i18next from 'i18next';

import { withStyles } from '@material-ui/core/styles';

import { connect } from "react-redux";
import { PAGES } from "./enum/pages";

import PageHeader from 'widgets/PageHeader';
import PageFooter from 'widgets/PageFooter';

import FormPage from './pages/FormPage';
import CompletedPage from './pages/CompletedPage';

import { withTranslation } from 'react-i18next';
import './style/style.css';
import { setPage } from "./redux/actions";

const styles = () => ({
	pageContent: {
		paddingBottom: "1em",
	},
});

interface PassInProperty{
	classes: object,
	withHeader: boolean,
	activePage: string,
	withFooter: boolean
}	

const mapStateToProps = state => {
  const { activePage } = state;

  return { activePage };
};

@connect(mapStateToProps, {setPage})
@withTranslation()
@withStyles(styles)
class Main extends React.Component<PassInProperty>{

	constructor(props){
		super(props);
		
		function getUrlVars() {
			const vars = {};
			window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
				vars[key] = value;
			});
			return vars;
		}

		const lang = getUrlVars()["lang"] ? getUrlVars()["lang"] : "";
		if(lang === "zh" || lang === "en") {
			i18next.changeLanguage(lang);
		}
	}

	render(){
		
		const {classes, withHeader, activePage, withFooter} = this.props;
		
		return (
			<div>
				{(withHeader == null || withHeader) &&
				<PageHeader
					showHeader={true}
				/>
				}

				<div className={`content ${classes.pageContent}`}>

					{activePage == PAGES.HOMEPAGE &&
						<FormPage
						/>
					}

					{activePage == PAGES.COMPLETE &&
						<CompletedPage
						/>
					}

				</div>

				{(withFooter == null || withFooter) &&
				<PageFooter
					hotline='3666 7018'
					withFAQ={false}
				/>
				}

			</div>
		);
	};
	
}

export default Main;